export default "__VITE_ASSET__B1M_J4FK__"